import { createSelector } from 'reselect';
import { getWorkOrderOperationProgress } from './getWorkOrderOperationProgress';

export const getWorkOrderOpTotalParts = createSelector(
  [getWorkOrderOperationProgress],
  ({ workOrderOpTotalParts }) => {
    return workOrderOpTotalParts;
  }
);
